<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <div class="container">
            <router-link class="navbar-brand" :to="{path: '/'}">{{ $root.siteName }}</router-link>
            <button class="navbar-toggler" type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                    aria-controls="navbarCollapse"
                    aria-expanded="false"
                    aria-label="Menu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <button class="navbar-toggler" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                        aria-controls="navbarCollapse"
                        aria-expanded="false"
                        aria-label="Menu">
                    <i class="fe fe-x"></i>
                </button>
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <router-link :to="{path: '/dashboard'}" class="nav-link">Dashboard</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/tokens'}" class="nav-link">Tokens</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/affiliate'}" class="nav-link">Affiliate</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/plan'}" class="nav-link">Plan</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/billing'}" class="nav-link">Billing</router-link>
                    </li>
                </ul>
                <router-link :to="{path: '/logout'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto" v-if="$root.context.id">
                    Logout
                </router-link>
                <router-link :to="{path: '/login'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto" v-else>
                    Login
                </router-link>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <div class="avatar avatar-lg" style="margin-left:10px">
                            <router-link :to="{path: '/settings'}">
                                <img :src="`https://www.gravatar.com/avatar/${$root.context.gravatar_hash}`" class="avatar-img rounded-circle">
                            </router-link>
                        </div>
                     </li>
                </ul>
            </div>
        </div>
    </nav>
    <main>
        <section v-if="$root.context.is_unverified_trial">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="alert alert-success" role="alert">
                            <p>
                                To activate the trial you need to confirm your Telegram ID through our bot by <a :href="`${$root.siteTgBase}/${$root.context.tg_bot}?start=${$root.context.token}`">the link</a>
                            </p>
                            <div>
                                <h5>Enjoying our service? Share your experience!</h5>
                                <ul>
                                    <li>
                                        📝 {{ reviewPlatform.prompt }}
                                        <a :href="reviewPlatform.url" target="_blank">
                                          {{ reviewPlatform.name }}
                                        </a>
                                        {{ reviewPlatform.suffix }}
                                    </li>
                                    <li v-for="detail in (reviewPlatform.details || [])" :key="detail">{{ detail }}</li>
                                    <li v-if="reviewPlatform.cta" v-html="'💬 ' + reviewPlatform.cta"></li>
                                    <template v-if="!reviewPlatform.details">
                                        <li>🧠 A few words about your experience go a long way</li>
                                        <li>💬 Let us know at <a :href="`${$root.siteTgBase}/${$root.siteTgSupport}`">@{{ $root.siteTgSupport }}</a> once you've shared your thoughts — we have a little something for active users 😉</li>
                                    </template>
                                </ul>
                                <p v-if="reviewPlatform.footer" class="mb-0 mt-2" style="font-size: 0.9em;">
                                    🤝 {{ reviewPlatform.footer }}
                                </p>
                                <p class="mb-0 mt-2" style="font-size: 0.9em;">
                                    Had a bad experience? Let us know at
                                    <a :href="`${$root.siteTgBase}/${$root.siteTgSupport}`">@{{ $root.siteTgSupport }}</a> or
                                    <a :href="`mailto:${$root.siteEmail}`">{{ $root.siteEmail }}</a>
                                    — we'd love to fix it!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <router-view></router-view>
    </main>
    <div class="position-relative">
        <div class="shape shape-bottom shape-fluid-x svg-shim text-gray-200">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor"/></svg>
        </div>
    </div>
    <footer class="py-8 py-md-11 bg-gray-200">
        <Footer />
    </footer>
</div>
</template>
<script>
import { EventBus } from "@/bus"
import Footer from './Footer'
export default {
    components: { Footer },
    created() {
        EventBus.on("context:loaded", this.checkLogin)
        if (!this.$root.context.id) {
            EventBus.emit("context:request")
        }
    },
    beforeUnmount() {
        EventBus.off("context:loaded", this.checkLogin)
    },
    watch: {
        $route() {
            this.checkLogin(this.$root.context)
        }
    },
    computed: {
        reviewPlatforms() {
            const domain = this.$root.siteDomain
            const site = this.$root.siteName
            const tg = this.$root.siteTgSupport
            const tgBase = this.$root.siteTgBase
            return [
                {
                    name: 'Trustpilot',
                    prompt: 'Leave an honest review on',
                    suffix: 'from a verified account',
                    url: `https://www.trustpilot.com/review/${domain}`,
                },
                {
                    name: 'Reddit',
                    prompt: 'Earn API credits by writing about us on',
                    suffix: '',
                    url: 'https://www.reddit.com/',
                    details: [
                        `Share a post or comment about ${site} in a relevant subreddit — get up to $50 in credits. More upvotes = bigger bonus.`,
                        'Try: r/TikTok, r/tiktokmarketing, r/socialmedia, r/socialmediamarketing, r/webscraping, r/python, r/automation, r/SaaS, r/sideproject',
                        'Ideas: tutorial, project showcase, API comparison, automation case study, creator analytics walkthrough',
                    ],
                    cta: `Send your link to <a href="${tgBase}/${tg}">@${tg}</a> on Telegram to claim your reward`,
                    footer: 'Got a following? We offer custom deals for content creators — reach out for personalized terms.',
                },
            ]
        },
        reviewPlatform() {
            const id = this.$root.context.id || 0
            return this.reviewPlatforms[id % this.reviewPlatforms.length]
        },
    },
    methods: {
        checkLogin(context) {
            if (context.loaded && !context.id) {
                window.location.href = '/login'
            }
        }
    }
}
</script>
